import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, of, tap, throwError } from 'rxjs';
import { HttpHeaders, HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AgentListResponse, AgentStatusResponse, AuthResponse, ChatListResponse, ChatRoomMembersResponse, GetMessageResponse, UserChatHistoryMessagesResponse } from '../model/user-interfaces';
import { stringify } from '../model/query-string-service';
import { GET_CHAT_ENV_URL } from 'src/app/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  CHAT_API_BASE_URL = GET_CHAT_ENV_URL();

  private toggleHeaderSubject = new BehaviorSubject<string>('Dashboard');
  toggleHeaderData$ = this.toggleHeaderSubject.asObservable();

  private removeSelectedRecords = new BehaviorSubject<any>([]);
  removeSelectedRecords$ = this.removeSelectedRecords.asObservable();
  constructor(private http: HttpClient) {
  }

  HandleResponse(response: any) {
    console.log('response of call:--', response);
  }

  login(data: any) {
    return this.http.post<AuthResponse>(
      `${this.CHAT_API_BASE_URL}/auth/login`, data
    );
  }

  getFileAsBlob(fileUrl: string) {
    return this.http.post(
      `${environment.chatUrl}/rooms/messages/get-file-blog`,
      { url: fileUrl },
      {
        responseType: 'blob'
      }
    );
  }


  refreshChatToken(_token = '') {
    let token = localStorage.getItem(environment.X_Refresh_Token) ? environment.X_Refresh_Token : '';

    if (_token?.trim()?.length) {
      token = _token;
    }
    if (!token?.trim()) {
      return of({
        success: false,
        failedToRefresh: true,
        message: 'Token not found'
      });
    }
    return this.http.post(this.CHAT_API_BASE_URL + '/auth/refresh-token', {
      token: token,
    });
  }

  //get message by tMid
  getMessageByTmid(tmid: string, roomId: number) {
    return this.http.post(`${this.CHAT_API_BASE_URL}/rooms/messages/tmid`, {
      tmid: tmid,
      roomId: roomId
    });
  }

  //upload file using formdata
  uploadFileToS3(formData: FormData) {
    return this.http.post(
      `${this.CHAT_API_BASE_URL}/file/upload`,
      formData
    );
  }

  postChatFiles(data) {
    return this.http.post(
      `${this.CHAT_API_BASE_URL}/rooms/messages/upload-file`, data
    );
  }

  // createAgent(data) {
  //   return this.http.post(`${this.CHAT_API_BASE_URL}/users`, data
  //   );
  // }

  getAgents(pagination) {
    return this.http.get<AgentListResponse>(
      `${this.CHAT_API_BASE_URL}/users/agent-list?${stringify(pagination)}`,
    );
  }


  getUserChatHistory(userId: number, roomId: number, pagination) {
    return this.http.get<UserChatHistoryMessagesResponse>(
      `${this.CHAT_API_BASE_URL}/chat/customer/chat-history/${userId + '/' + roomId}?${stringify(pagination)}`,
    );
  }

  // getFAQs(pagination) {
  //   return this.http.get<AgentListResponse>(
  //     `${this.CHAT_API_BASE_URL}/faq/faq-list?${stringify(pagination)}`,
  //   );
  // }

  // createFAQ(data) {
  //   return this.http.post(`${this.CHAT_API_BASE_URL}/faq`, data
  //   );
  // }

  removeAssignedRoom(roomId: number) {
    return this.http.get(`${this.CHAT_API_BASE_URL}/rooms/assign-room/` + roomId
    );
  }

  getUserById(userId: number) {
    return this.http.get(
      `${this.CHAT_API_BASE_URL}/users/` + userId
    );
  }


  getChatMessages(params: any, roomId: number, userId: number) {
    params.userId = userId;
    return this.http.get<GetMessageResponse>(`${this.CHAT_API_BASE_URL}/rooms/messages/${roomId}?${stringify(params)}`
    );
  }

  getRoomMembers(params: any, roomId: number) {
    return this.http.get<ChatRoomMembersResponse>(`${this.CHAT_API_BASE_URL}/member/${roomId}?${stringify(params)}`
    );
  }

  getAllUnassignedChats(params: any) {
    return this.http.get<ChatListResponse>(`${this.CHAT_API_BASE_URL}/chat/unassign-chat-list?${stringify(params)}`
    );
  }

  getAllMentionedChats(params: any) {
    return this.http.get<ChatListResponse>(`${this.CHAT_API_BASE_URL}/chat/mentions-chat-list?${stringify(params)}`
    );
  }

  getAllLiveChats(params: any) {
    return this.http.get<ChatListResponse>(`${this.CHAT_API_BASE_URL}/chat/chat-list?${stringify(params)}`
    );
  }

  getAgentChatHistory(params: any, id: number) {
    return this.http.get(`${this.CHAT_API_BASE_URL}/chat/chat-history/${id}?${stringify(params)}`
    );
  }

  getLiveChatsOfAllAgents(params: any) {
    return this.http.get<ChatListResponse>(`${this.CHAT_API_BASE_URL}/chat/ongoing-chat-list?${stringify(params)}`
    );
  }

  closeRoom(roomId: number) {
    return this.http.get(`${this.CHAT_API_BASE_URL}/rooms/close-room/${roomId}`
    );
  }

  getUserDetails(userId: number) {
    return this.http.get(`${this.CHAT_API_BASE_URL}/users/profile/${userId}`
    );
  }

  // getAgentsStats() {
  //   return this.http.get<AgentStatusResponse>(`${this.CHAT_API_BASE_URL}/users/agent-status`
  //   );
  // }

  setToggleHeaderData(data: any) {
    this.toggleHeaderSubject.next(data);
  }

  setRemoveSelectedRecords(data: any) {
    this.removeSelectedRecords.next(data);
  }

  // updateFAQ(id: any, params: any) {
  //   return this.http.put(`${this.CHAT_API_BASE_URL}/faq/update/${id}`, params);
  // }

  updateAgent(id: any, params: any) {
    return this.http.post(`${this.CHAT_API_BASE_URL}/users/update/${id}`, params);
  }


}
